import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './close_toaster_button.module.scss';

export const CloseToasterButton: FC<{
  closeToast?: () => void;
  color?: string;
}> = ({ closeToast = () => {}, color = 'white' }) => (
  <button
    type="button"
    className={classNames(
      styles.close,
      { [styles.white]: color === 'white' },
      { [styles.black]: color === 'black' },
    )}
    onClick={closeToast}
  >
    <i className={classNames('material-icons', 'icons__close', styles.icon)} />
  </button>
);
